import {PortalModule} from '@angular/cdk/portal';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {Q9TrackDirective} from '@q9elements/ui-kit/common';
import {
  ButtonToggleGroupModule,
  ContentLoaderComponent,
  DialogCloseButtonComponent,
  FollowStarComponent,
  IconButtonComponent,
  InfoMessageComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent,
  SectionComponent,
  SidebarModule,
  TagsSelectComponent,
  TextFieldComponent,
  TextareaFieldComponent,
  UserInfoComponent
} from '@q9elements/ui-kit/components';
import {OrgNodeSidebarModule} from '@q9elements/ui-kit/refmodels';
import {ChangesTabComponent} from './components/changes-tab/changes-tab.component';
import {ClassificationTabComponent} from './components/classification-tab/classification-tab.component';
import {FeedbacksTabComponent} from './components/feedbacks-tab/feedbacks-tab.component';
import {InsightTabComponent} from './components/insight-tab/insight-tab.component';
import {DetailsTabComponent} from './components/node-details-tab/node-details-tab.component';
import {PlannedChangesTabComponent} from './components/planned-changes-tab/planned-changes-tab.component';
import {RootDetailsTabComponent} from './components/root-details-tab/root-details-tab.component';
import {StakeholdersTabComponent} from './components/stakeholders-tab/stakeholders-tab.component';
import {SystemInfoTabComponent} from './components/system-info-tab/system-info-tab.component';
import {EditModelDialogComponent} from './dialogs/edit-model-dialog/edit-model-dialog.component';
import {InternalSidebarComponent} from './internal-sidebar.component';

@NgModule({
  declarations: [
    InternalSidebarComponent,
    RootDetailsTabComponent,
    DetailsTabComponent,
    InsightTabComponent,
    SystemInfoTabComponent,
    StakeholdersTabComponent,
    PlannedChangesTabComponent,
    FeedbacksTabComponent,
    ChangesTabComponent,
    EditModelDialogComponent,
    ClassificationTabComponent
  ],
  exports: [InternalSidebarComponent],
  imports: [
    CommonModule,
    SidebarModule,
    IconButtonComponent,
    Q9TrackDirective,
    TranslateModule,
    MatTooltipModule,
    ButtonToggleGroupModule,
    PortalModule,
    FormsModule,
    OrgNodeSidebarModule,
    FollowStarComponent,
    SectionComponent,
    UserInfoComponent,
    MatDialogModule,
    DialogCloseButtonComponent,
    TextFieldComponent,
    TextareaFieldComponent,
    ReactiveFormsModule,
    InfoMessageComponent,
    SecondaryButtonComponent,
    PrimaryButtonComponent,
    TagsSelectComponent,
    ContentLoaderComponent
  ]
})
export class InternalSidebarModule {}
